import { render, staticRenderFns } from "./starrating.vue?vue&type=template&id=b2cd6676&"
import script from "./starrating.vue?vue&type=script&lang=js&"
export * from "./starrating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2cd6676')) {
      api.createRecord('b2cd6676', component.options)
    } else {
      api.reload('b2cd6676', component.options)
    }
    module.hot.accept("./starrating.vue?vue&type=template&id=b2cd6676&", function () {
      api.rerender('b2cd6676', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2rYR2oHuJ35SY/JS/comp/starrating.vue"
export default component.exports